var routes = [
	{
		name: "landing",
		path: "/",
		component: () => import("@/views/Landing")
	},
	{
		path: "/investor",
		component: () => import("@/pages/Webapp"),
		children: [
			{
				name: "home",
				path: "",
				component: () => import("@/views/Home")
			},
			{
				name: "faq",
				path: "faq",
				component: () => import("@/views/FAQ")
			},
			{
				name: "messages",
				path: "messages",
				component: () => import("@/views/Messages")
			},
			{
				name: "create-support-ticket",
				path: "contact/create",
				component: () => import("@/components/support/CreateTicketMenu")
			},
			{
				name: "ticket-message-view",
				path: "contact/:id",
				component: () => import("@/views/TicketMessageView")
			},
			{
				name: "account",
				path: "investments",
				component: () => import("@/views/Investments")
			},
			{
				name: "updates",
				path: "updates",
				component: () => import("@/views/Updates")
			},
			{
				name: "investor-article-view",
				path: "updates/:slug",
				component: () => import("@/views/InvestorArticleView")
			}
		]
	},

];
export default routes;
